/* global Modernizr */

const $categories = $('.js-categories');
const $toggler = $('.js-categories-toggler');
const $categoriesHeight = $categories.height();

const categories = {
  initialize() {
    if ($categories.length && Modernizr.mq('(min-width: 991px)')) {
      this.toggleCategories(false);

      this.createListeners();
    }
  },

  createListeners() {
    $toggler.on('click', () => {
      $categories.toggleClass('is-open');

      const isOpen = $categories.hasClass('is-open');

      $categories.attr('aria-expanded', isOpen);
      $toggler.text(isOpen ? $toggler.data('expanded-text') : $toggler.data('collapsed-text'));

      this.toggleCategories(isOpen);
    });
  },

  toggleCategories(open) {
    $categories.css({
      height: open ? $categoriesHeight : '62px',
    });
  },
};

export default categories;
